export const FETCH_BRAND_CURATION_TASKS = {
  START: 'START_FETCH_BRAND_CURATION_TASKS',
  COMPLETE: 'COMPLETE_FETCH_BRAND_CURATION_TASKS',
  FAIL: 'FAIL_FETCH_BRAND_CURATION_TASKS',
  CLEANUP: 'CLEANUP_FETCH_BRAND_CURATION_TASKS',
}

export const ASSIGN_BRAND_CURATION_TASK_USER = {
  START: 'START_ASSIGN_BRAND_CURATION_TASK_USER',
  COMPLETE: 'COMPLETE_ASSIGN_BRAND_CURATION_TASK_USER',
  FAIL: 'FAIL_ASSIGN_BRAND_CURATION_TASK_USER',
}

export const DELETE_FAKE_BRAND = {
  START: 'START_DELETE_FAKE_BRAND',
  COMPLETE: 'COMPLETE_DELETE_FAKE_BRAND',
  FAIL: 'FAIL_DELETE_FAKE_BRAND',
}

export const UPDATE_BRAND_CURATION_TASK_PERSISTED_FILTERS =
  'UPDATE_BRAND_CURATION_TASK_PERSISTED_FILTERS'
